import { render, staticRenderFns } from "./BrbUploader.vue?vue&type=template&id=2efeb73e&scoped=true&"
import script from "./BrbUploader.vue?vue&type=script&lang=js&"
export * from "./BrbUploader.vue?vue&type=script&lang=js&"
import style0 from "./BrbUploader.vue?vue&type=style&index=0&id=2efeb73e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2efeb73e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/matin/baarbaanet/frontend/panel/driver/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2efeb73e')) {
      api.createRecord('2efeb73e', component.options)
    } else {
      api.reload('2efeb73e', component.options)
    }
    module.hot.accept("./BrbUploader.vue?vue&type=template&id=2efeb73e&scoped=true&", function () {
      api.rerender('2efeb73e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/shared/brb-components/brb-uploader/BrbUploader.vue"
export default component.exports